import axios from '../../../services/axios.service';
import { getEndpointBase } from '../../../services/api.service';
import { HrWidgetDTO, HrWidgetResponse } from './HRWidget.type';
import { AxiosResponse } from 'axios';

let request: any = null;

const REQUEST = 'widget/hr-widget';

export const hrWidgetService = {
  get: (): Promise<AxiosResponse<HrWidgetResponse>> => {
    request && request.cancel();
    request = axios.CancelToken.source();

    return axios.get(getEndpointBase(REQUEST), {
      cancelToken: request.token,
    });
  },

  save: (data: HrWidgetDTO): Promise<AxiosResponse<HrWidgetResponse>> => {
    return axios.post(getEndpointBase(REQUEST), data);
  },
};
